import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);
export default {
  init() {

    var introTL = gsap.timeline({
      scrollTrigger : {
        trigger: "#block-home-intro",
        start: 'top top',
        toggleActions: 'play none none none'
      }
    });

    gsap.set('.top-circle', {y:-400});
    gsap.set('.cimplifibg', {autoAlpha:1, rotate: 760});

    gsap.to('.cimplifibg', {rotate: 720, duration: 30});
    
    gsap.to('.top-circle',{
      scrollTrigger : {
        trigger : '#block-home-intro',
        start: 'top center',
      },
      y:0
    });
  },
  finalize() {}
}